export enum EBlockListAlias {
    FINGERPRINT = 'card_fingerprint_blocklist',
    EMAIL = 'email_blocklist'
}

export enum EReportingListAlias {
    SCHEDULES = 'schedules',
    REPORTING = 'reports'
}
